const CQ_AGE_FILTER_PARAM = 'filter.p.m.characterquilt.age_group';
const CQ_KIDS_AGE_VALUES = ['Youth', 'Toddler', 'Infant'];
const cqObservedFacetContainers = new WeakSet();
let cqAvailabilityRefreshQueued = false;

function ensureAvailabilityFilter() {
  const url = new URL(window.location.href);
  const pathname = url.pathname;
  const isSearchPage = pathname === '/search' || pathname.startsWith('/search/');
  const isCollectionPage = pathname.startsWith('/collections/');

  if (!isSearchPage && !isCollectionPage) return;

  const hasAvailabilityFilter = url.searchParams.has('filter.v.availability');
  if (!hasAvailabilityFilter) url.searchParams.set('filter.v.availability', '1');

  let kidsAgeAdded = false;
  const normalizedQuery = (url.searchParams.get('q') || '').trim().toLowerCase();
  if (
    isSearchPage &&
    normalizedQuery === 'kids' &&
    !url.searchParams.has(CQ_AGE_FILTER_PARAM)
  ) {
    for (const ageValue of CQ_KIDS_AGE_VALUES) {
      url.searchParams.append(CQ_AGE_FILTER_PARAM, ageValue);
    }
    kidsAgeAdded = true;
  }

  if (!hasAvailabilityFilter || kidsAgeAdded) {
    // These filters must be applied by Shopify on the initial request. Updating
    // browser history and dispatching theme events only changed the visible URL,
    // leaving the original unfiltered result cohort on screen.
    window.location.replace(url.toString());
    return;
  }
}

function hideFacetItem(element) {
  const facetItem = element.closest('.facets__item');
  if (facetItem) facetItem.style.display = 'none';
}

function hideAvailabilityControls() {
  document
    .querySelectorAll(
      '[data-filter-param-name="v-availability"], [name*="v.availability"]',
    )
    .forEach(hideFacetItem);

  document
    .querySelectorAll('input[name="filter.p.tag"][value="has-image"]')
    .forEach(hideFacetItem);

  document.querySelectorAll('.facets__label').forEach((label) => {
    const text = label.textContent.toLowerCase();
    if (text.includes('availability') || text.includes('has image')) {
      hideFacetItem(label);
    }
  });
}

function hideFacetRemoveComponent(component) {
  component.style.display = 'none';
  component.setAttribute('hidden', 'true');
  component.style.visibility = 'hidden';
  component.style.opacity = '0';
  component.style.height = '0';
  component.style.margin = '0';
  component.style.padding = '0';
  component.style.overflow = 'hidden';
  component.style.pointerEvents = 'none';
}

function updateClearAllVisibility() {
  const url = new URL(window.location.href);
  const isKidsSearch =
    url.pathname.startsWith('/search') &&
    (url.searchParams.get('q') || '').trim().toLowerCase() === 'kids';
  const hasShopperFilter = Array.from(url.searchParams.entries()).some(
    ([name, value]) => {
      if (!name.startsWith('filter.')) return false;
      if (name === 'filter.v.availability') return false;
      if (name === 'filter.p.tag' && value === 'has-image') return false;
      if (
        isKidsSearch &&
        name === CQ_AGE_FILTER_PARAM &&
        CQ_KIDS_AGE_VALUES.includes(value)
      ) {
        return false;
      }
      return true;
    },
  );

  document
    .querySelectorAll(
      'facet-remove-component .facets__clear-all-link, facet-remove-component .facets__clear-all',
    )
    .forEach((clearButton) => {
      const component = clearButton.closest('facet-remove-component');
      if (!component) return;
      if (!hasShopperFilter) {
        component.dataset.cqHiddenNoShopperFilters = 'true';
        hideFacetRemoveComponent(component);
      } else if (component.dataset.cqHiddenNoShopperFilters === 'true') {
        delete component.dataset.cqHiddenNoShopperFilters;
        component.removeAttribute('hidden');
        component.removeAttribute('style');
      }
    });
}

function hideAvailabilityPills() {
  document.querySelectorAll('facet-remove-component').forEach((component) => {
    const textContent = component.textContent.trim();
    const normalizedText = textContent.toLowerCase();
    const dataUrl = component.getAttribute('data-url') || '';
    const isAvailability =
      textContent === 'In stock' ||
      normalizedText === 'has-image' ||
      normalizedText.includes('has-image') ||
      normalizedText.includes('has image') ||
      dataUrl.includes('filter.p.tag=has-image') ||
      dataUrl.includes('filter.p.tag%3Dhas-image');

    if (isAvailability) hideFacetRemoveComponent(component);
  });
}

function setupClearAllButtons() {
  document
    .querySelectorAll(
      'facet-remove-component .facets__clear-all-link, facet-remove-component .facets__clear-all',
    )
    .forEach((clearButton) => {
      if (clearButton.dataset.cqClearAllBound === 'true') return;
      const component = clearButton.closest('facet-remove-component');
      if (!component) return;

      const newButton = clearButton.cloneNode(true);
      newButton.dataset.cqClearAllBound = 'true';
      clearButton.parentNode.replaceChild(newButton, clearButton);

      newButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const dataUrl = component.getAttribute('data-url') || '';
        const currentUrl = new URL(window.location.href);
        const isSearchPage =
          currentUrl.pathname === '/search' ||
          currentUrl.pathname.startsWith('/search/');

        let targetUrl;
        try {
          targetUrl = new URL(dataUrl, window.location.origin);
        } catch {
          targetUrl = new URL(
            dataUrl.startsWith('?')
              ? `${window.location.pathname}${dataUrl}`
              : dataUrl,
            window.location.origin,
          );
        }

        const basePath = isSearchPage ? '/search' : window.location.pathname;
        const newUrl = new URL(basePath, window.location.origin);

        if (isSearchPage) {
          const searchQuery =
            currentUrl.searchParams.get('q') ||
            targetUrl.searchParams.get('q') ||
            '';
          if (searchQuery) newUrl.searchParams.set('q', searchQuery);

          const optionsPrefix =
            currentUrl.searchParams.get('options[prefix]') ||
            targetUrl.searchParams.get('options[prefix]') ||
            'last';
          newUrl.searchParams.set('options[prefix]', optionsPrefix);
        }

        const sortBy =
          currentUrl.searchParams.get('sort_by') ||
          targetUrl.searchParams.get('sort_by') ||
          (isSearchPage ? 'relevance' : 'best-selling');
        if (sortBy) newUrl.searchParams.set('sort_by', sortBy);

        newUrl.searchParams.set('filter.v.availability', '1');

        const facetsForm = component.closest('facets-form-component');
        if (facetsForm && typeof facetsForm.updateFiltersByURL === 'function') {
          facetsForm.updateFiltersByURL(newUrl.toString());
        } else {
          window.location.href = newUrl.toString();
        }
      });
    });
}

function observeFacetRemoveContainers() {
  document.querySelectorAll('.facets-remove').forEach((container) => {
    if (cqObservedFacetContainers.has(container)) return;
    cqObservedFacetContainers.add(container);
    cqFacetRemoveObserver.observe(container, { childList: true, subtree: true });
  });
}

function refreshAvailabilityUI() {
  hideAvailabilityControls();
  hideAvailabilityPills();
  setupClearAllButtons();
  updateClearAllVisibility();
  observeFacetRemoveContainers();
}

function scheduleAvailabilityRefresh() {
  if (cqAvailabilityRefreshQueued) return;
  cqAvailabilityRefreshQueued = true;
  requestAnimationFrame(() => {
    cqAvailabilityRefreshQueued = false;
    refreshAvailabilityUI();
  });
}

const cqFacetRemoveObserver = new MutationObserver(scheduleAvailabilityRefresh);

function initializeAvailabilityFilter() {
  ensureAvailabilityFilter();
  refreshAvailabilityUI();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAvailabilityFilter, {
    once: true,
  });
} else {
  initializeAvailabilityFilter();
}

document.addEventListener('FilterUpdate', scheduleAvailabilityRefresh);
